import RowRecord from './RowRecord.view';

export default RowRecord;
